import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleShoppingGuide = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("product-categories");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("product-categories");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <nav
      className={`w-full sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md border-b border-background-200 shadow-sm" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-3.5 flex items-center justify-between">
        <Link to="/" className="font-heading text-lg font-bold text-foreground-950 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          GTBuy Spreadsheet
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              location.pathname === "/" ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
            }`}
          >
            <i className="ri-home-4-line w-4 h-4 flex items-center justify-center inline mr-1.5 align-middle"></i>
            Home
          </Link>
          <button
            onClick={handleShoppingGuide}
            className="text-sm font-medium text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center inline mr-1.5 align-middle"></i>
            Shopping Guide
          </button>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer hover:scale-105"
          >
            <i className="ri-shopping-cart-2-line w-4 h-4 flex items-center justify-center"></i>
            gtbuy sheet
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation menu"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} w-6 h-6 flex items-center justify-center`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-5 space-y-4">
          <Link
            to="/"
            className="flex items-center gap-3 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer py-2"
          >
            <i className="ri-home-4-line w-5 h-5 flex items-center justify-center"></i>
            Home
          </Link>
          <button
            onClick={handleShoppingGuide}
            className="flex items-center gap-3 text-sm font-medium text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer py-2 w-full text-left"
          >
            <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center"></i>
            Shopping Guide
          </button>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer"
          >
            <i className="ri-shopping-cart-2-line w-4 h-4 flex items-center justify-center"></i>
            gtbuy sheet
          </a>
        </div>
      )}
    </nav>
  );
}